import { Container, Row, Col } from "react-bootstrap";
import pirate from "../assets/img/pirate.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={pirate} alt="Pirate" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/vinh-pham-8ba02111b/">
                <img src={navIcon1} alt="Icon" />
              </a>
              <a href="https://www.facebook.com/vinhhhpham">
                <img src={navIcon2} alt="Icon" />
              </a>
              <a href="https://www.instagram.com/ocd.vinh/">
                <img src={navIcon3} alt="Icon" />
              </a>
            </div>
            <p>Copyright 2022. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
